import React from "react";

import { TemplateName } from "../../../../../../types/templates/template-name";
import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { RichTextField } from "../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlContent = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <RichTextField
      form={props.form}
      label="Campaign Overview"
      name="campaignContent"
      required
      subTitle={TemplateName.CampaignBrief.Brand}
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
